import React, { FunctionComponent, useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { MyTextFiled } from '../UI/MyTextField';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyButton } from '../UI/MyButton';
import { MyAlert } from '../UI/MyAlert';
import { CloudDto } from '../../dto/CloudDto';
import { apiAddCloud } from '../../service/apiAddCloud';

interface Props {
  pageNum: number;
  open: boolean;
  onClose: () => void;
  onSave: (e: any) => void;
}

export const DialogAddToCloud: FunctionComponent<Props> = ({
  pageNum,
  open,
  onClose,
  onSave,
}) => {
  const [cloudDto, setCloudDto] = useState<CloudDto>({
    id: '',
    section: '',
    route: '',
    page: '',
    name: '',
  });
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const [backDrop, setBackDrop] = useState(false);
  const [checkHelper, setCheckHelper] = useState(false);
  const handleClose = () => {
    setCloudDto({
      id: '',
      name: '',
    });
    setCheckHelper(false);
    onClose();
  };
  const handleSave = (id: string) => {
    onSave(id);
  };
  const { section, route } = useParams();
  const addCloud = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiAddCloud(
      section ?? '',
      route ?? '',
      `${pageNum}`,
      cloudDto
    );
    if (apiResult.isSuccess) {
      handleSave(cloudDto.name);
      handleClose();
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const handleAdd = async () => {
    if (cloudDto.name === '') {
      setCheckHelper(true);
      return;
    }
    await addCloud();
    setCheckHelper(false);
  };

  useEffect(() => {
    setCloudDto({
      id: '',
      name: '',
    });
    setCheckHelper(false);
  }, []);

  return (
    <div>
      <BackDropDiv open={backDrop} />
      <Dialog
        open={open}
        fullWidth
        maxWidth="md"
        style={{ userSelect: 'none' }}
        PaperProps={{ sx: { backgroundColor: '#e7ebee', width: '100%' } }}
      >
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontSize: '16px',
                textAlign: 'left',
                fontWeight: '600',
              }}
              component="text"
            >
              Добавить в облако
            </Typography>
            <IconButton size="medium" onClick={onClose}>
              <CloseIcon fontSize="medium" />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack padding="0px" spacing={1}>
            <MyTextFiled
              value={cloudDto.name}
              onChange={(e) =>
                setCloudDto({
                  ...cloudDto,
                  name: e.target.value,
                })
              }
              error={checkHelper}
              multiLine
              size="small"
              label="Идентификатор"
            />
            <Stack paddingTop="20px" alignItems="center">
              <MyButton
                width="120px"
                text="Добавить"
                background="#9c27b0"
                height="50px"
                onClick={handleAdd}
              />
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};
